import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { validate, mergeStyles } from 'wix-rich-content-common';
import pluginGiphySchema from 'wix-rich-content-common/dist/statics/schemas/plugin-giphy.schema.json';
import { isEqual } from 'lodash';
import { s as styles } from './giphy-viewer-155fbabc.js';
import './style-inject.es-746bb8ed.js';

class GiphyViewer extends Component {
  constructor(props) {
    super(props);
    validate(props.componentData, pluginGiphySchema);
  }
  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.componentData, this.props.componentData)) {
      validate(nextProps.componentData, pluginGiphySchema);
    }
  }
  render() {
    this.styles = this.styles || mergeStyles({ styles, theme: this.props.theme });
    const { componentData, setComponentUrl } = this.props;
    const { gif } = componentData;
    if (!gif.originalMp4 && !gif.originalUrl) {
      return null;
    }
    setComponentUrl == null ? void 0 : setComponentUrl(gif.originalMp4 ? gif.originalMp4 : gif.originalUrl);
    if (gif.originalMp4) {
      return (
        // video should be treated as an noninteractive git element
        /* eslint-disable jsx-a11y/no-redundant-roles, jsx-a11y/no-interactive-element-to-noninteractive-role*/
        /* @__PURE__ */ React.createElement(
          "video",
          {
            role: "img",
            autoPlay: true,
            muted: true,
            loop: true,
            playsInline: true,
            "aria-label": "gif",
            className: this.styles.giphy_player,
            src: gif.originalMp4
          }
        )
      );
    }
    return /* @__PURE__ */ React.createElement(
      "img",
      {
        role: "img",
        "aria-label": "gif",
        className: this.styles.giphy_player,
        src: gif.originalUrl,
        alt: "gif"
      }
    );
  }
}
GiphyViewer.propTypes = {
  componentData: PropTypes.object.isRequired,
  onReady: PropTypes.func,
  onStart: PropTypes.func,
  controls: PropTypes.bool,
  width: PropTypes.string,
  height: PropTypes.string,
  settings: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
  setComponentUrl: PropTypes.func
};
GiphyViewer.defaultProps = {
  width: "100%",
  height: "100%",
  controls: true
};

export { GiphyViewer as default };
//# sourceMappingURL=giphy-viewer.js.map
